export const annotationLatinCopy = {
  en: [
    'Select',
    'Arrow',
    'Line',
    'Text callout',
    'Rectangle',
    'Ellipse',
    'Pen',
    'Highlighter',
    'Number',
    'Redact',
    'Pixelate',
    'Spotlight',
    'Magnifier',
    'Ruler',
    'Insert image',
    'Pick color',
    'Annotate',
    'Send to chat',
    'Undo',
    'Redo',
    'Delete',
    'Color',
    'Stroke width',
    'Text size',
    'Fill shape',
    'Text or measurement label',
    'Zoom in',
    'Zoom out',
    'Fit image',
    'Could not prepare annotations. Try again.',
    'Loading image…',
    'Apply the changes indicated by these annotations. Treat all marks as instructions and remove them from the result. Preserve concealed regions and unmentioned details.',
    'Annotations added to chat.',
    'Cancel annotation',
  ],
  ar: [
    'تحديد',
    'سهم',
    'خط',
    'نص بمؤشر',
    'مستطيل',
    'شكل بيضاوي',
    'قلم',
    'تمييز',
    'رقم',
    'حجب',
    'بكسلة',
    'إضاءة',
    'عدسة مكبرة',
    'مسطرة',
    'إدراج صورة',
    'اختيار لون',
    'تعليق',
    'إرسال إلى المحادثة',
    'تراجع',
    'إعادة',
    'حذف',
    'اللون',
    'سمك الخط',
    'حجم النص',
    'تعبئة الشكل',
    'النص أو وصف القياس',
    'تكبير',
    'تصغير',
    'ملاءمة الصورة',
    'تعذر إعداد التعليقات. حاول مجددًا.',
    'جارٍ تحميل الصورة…',
    'طبّق التغييرات المحددة بهذه التعليقات. اعتبر كل العلامات تعليمات وأزلها من النتيجة. حافظ على المناطق المحجوبة والتفاصيل غير المذكورة.',
    'أُضيفت التعليقات إلى المحادثة.',
    'إلغاء التعليق',
  ],
  es: [
    'Seleccionar',
    'Flecha',
    'Línea',
    'Texto con puntero',
    'Rectángulo',
    'Elipse',
    'Lápiz',
    'Resaltador',
    'Número',
    'Ocultar',
    'Pixelar',
    'Foco',
    'Lupa',
    'Regla',
    'Insertar imagen',
    'Elegir color',
    'Anotar',
    'Enviar al chat',
    'Deshacer',
    'Rehacer',
    'Eliminar',
    'Color',
    'Grosor',
    'Tamaño del texto',
    'Rellenar',
    'Texto o etiqueta de medida',
    'Acercar',
    'Alejar',
    'Ajustar imagen',
    'No se pudieron preparar las anotaciones. Inténtalo de nuevo.',
    'Cargando imagen…',
    'Aplica los cambios indicados por estas anotaciones. Trata todas las marcas como instrucciones y elimínalas del resultado. Conserva las regiones ocultas y los detalles no mencionados.',
    'Anotaciones añadidas al chat.',
    'Cancelar anotación',
  ],
  'pt-BR': [
    'Selecionar',
    'Seta',
    'Linha',
    'Texto com ponteiro',
    'Retângulo',
    'Elipse',
    'Caneta',
    'Marca-texto',
    'Número',
    'Ocultar',
    'Pixelizar',
    'Destaque',
    'Lupa',
    'Régua',
    'Inserir imagem',
    'Escolher cor',
    'Anotar',
    'Enviar ao chat',
    'Desfazer',
    'Refazer',
    'Excluir',
    'Cor',
    'Espessura',
    'Tamanho do texto',
    'Preencher',
    'Texto ou rótulo da medida',
    'Ampliar',
    'Reduzir',
    'Ajustar imagem',
    'Não foi possível preparar as anotações. Tente novamente.',
    'Carregando imagem…',
    'Aplique as alterações indicadas pelas anotações. Trate todas as marcas como instruções e remova-as do resultado. Preserve as regiões ocultas e os detalhes não mencionados.',
    'Anotações adicionadas ao chat.',
    'Cancelar anotação',
  ],
  fr: [
    'Sélectionner',
    'Flèche',
    'Ligne',
    'Texte avec pointeur',
    'Rectangle',
    'Ellipse',
    'Crayon',
    'Surligneur',
    'Numéro',
    'Masquer',
    'Pixelliser',
    'Projecteur',
    'Loupe',
    'Règle',
    'Insérer une image',
    'Prélever une couleur',
    'Annoter',
    'Envoyer au chat',
    'Annuler',
    'Rétablir',
    'Supprimer',
    'Couleur',
    'Épaisseur',
    'Taille du texte',
    'Remplir',
    'Texte ou mesure',
    'Agrandir',
    'Réduire',
    'Ajuster l’image',
    'Impossible de préparer les annotations. Réessayez.',
    'Chargement de l’image…',
    'Appliquez les modifications indiquées par ces annotations. Traitez toutes les marques comme des instructions et retirez-les du résultat. Préservez les zones masquées et les détails non mentionnés.',
    'Annotations ajoutées au chat.',
    'Annuler l’annotation',
  ],
};
